import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { CenteredFlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ContentWrapper = styled(CenteredFlexRow)`
    margin: 0 12px 5px 7px;
    height: 100%;
`;

export const TopPart = styled(FlexColumn)`
    align-items: center;
    height: 60%;
    justify-content: center;
`;

export const TotalVisitsWrapper = styled.div`
    color: ${colorsPalettes.carbon[500]};
    font-size: 44px;
    font-weight: 400;
    margin-bottom: 3px;
    line-height: 56px;
`;

export const LoaderWrapper = styled(CenteredFlexRow)`
    height: 100%;
`;
